<template>
  <div>
    <div class="padding-bottom-16" v-for="item in list" :key="item.id">
      <div class="list-item">
        {{ USER_STATUS[userStatus] }}
      </div>
      <div class="list-item" v-for="iten in item.logs" :key="iten.id">
        <div class="flex justify-between align-center">
          <div>{{ iten.title }}</div>
          <div class="text-grey1 text-12">
            {{ $formatDate(iten.operationTime) }}
          </div>
        </div>
        <div
          class="margin-top-16 bg-body padding-12 radius text-grey text-12"
          v-if="iten.result"
        >
          {{ iten.result }}
        </div>
      </div>
      <div class="list-item">
        <div class="flex justify-between align-center">
          <div>
            <span class="text-bold margin-right-16">{{
              item.questionName
            }}</span>
            <van-tag type="primary" plain size="medium">{{
              item.title
            }}</van-tag>
          </div>
          <div class="text-grey1 text-12">
            {{ $formatDate(item.createTime) }}
          </div>
        </div>
        <div
          class="margin-top-16 bg-body padding-12 radius text-grey text-12"
          v-if="item.content"
        >
          {{ item.content }}
        </div>

        <div v-if="item.imageUrls.length">
          <van-image
            class="margin-right-16 margin-top-16"
            v-for="iten in item.imageUrls"
            :key="iten"
            width="60"
            height="40"
            fit="contain"
            :src="iten"
            @click="imagePreview(item.imageUrls)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tag, Image as VanImage, ImagePreview } from 'vant'

import { USER_STATUS } from '@/utils/constant'

Vue.use(Tag).use(VanImage)
export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    },
    userStatus: {
      type: String,
      required: true,
      default: ''
    }
  },
  data () {
    return {
      USER_STATUS
    }
  },
  methods: {
    imagePreview (imageUrls) {
      ImagePreview(imageUrls)
    }
  }
}
</script>

<style lang="scss" scoped>
.list-item {
  position: relative;
  padding-bottom: 20px;
  padding-left: 20px;
  &::before {
    content: "";
    display: block;
    position: absolute;
    z-index: 2;
    left: 0px;
    top: 7px;
    width: 7px;
    height: 7px;
    border-radius: 1000px;
    background-color: $grey2;
  }
  &:first-child::before {
    background-color: $primary;
  }
  &:not(:last-child)::after {
    content: "";
    display: block;
    position: absolute;
    width: 0;
    height: 100%;
    left: 3px;
    top: 8px;
    border-left: 1px dotted $grey2;
  }
}
</style>
